import React from "react";
import { buttonText as defaultText } from "../../Utils/static-strings";

const ContinueButton = ({
  text = defaultText,
  onClick,
  className = "",
  style = {},
  id,
  href = "#",
  ...rest
}) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <a
      id={id}
      href={href}
      className={`af-class-button af-continue-button w-inline-block ${className}`.trim()}
      style={style}
      onClick={handleClick}
      {...rest}
    >
      <div
        style={{
          fontWeight: "var(--font-weight-semi-bold)",
          display: "flex",
          alignItems: "center",
        }}
      >
        {text}
        <svg
          aria-hidden="true"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginLeft: 10, verticalAlign: "middle" }}
        >
          <path d="M5 12h14" />
          <path d="M13 5l7 7-7 7" />
        </svg>
      </div>
    </a>
  );
};

export default ContinueButton;
